import React, { FC, useState } from 'react';

import { useQuery } from '@apollo/react-hooks';
import { Loader } from '../../../../components/Loader';
import { GET_COMPANY_OWNER_SUBSCRIPTION_INFORMATION } from '../../../../graphql/user';
import { Query } from '../../../../types';
import { SubscriptionInfo } from '../SubscriptionInfo';

interface OwnerSubscriptionProps {
  chargeBeeSite?: string;
  companyName?: string;
}

const OwnerSubscription: FC<OwnerSubscriptionProps> = ({ companyName, chargeBeeSite }) => {
  const { data, loading, refetch: refetchOwnerSubscription } = useQuery<
    Pick<Query, 'getMySubscriptionCompanyOwnerChargebeeInfo'>
  >(GET_COMPANY_OWNER_SUBSCRIPTION_INFORMATION, {
    fetchPolicy: 'network-only',
  });

  const info = data?.getMySubscriptionCompanyOwnerChargebeeInfo;

  const [refetchLoading, setRefetchLoading] = useState<boolean>(false);

  if (loading || refetchLoading) {
    return <Loader />;
  }

  return (
    <SubscriptionInfo
      info={info}
      companyName={companyName}
      refetchOwnerSubscription={refetchOwnerSubscription}
      setRefetchLoading={setRefetchLoading}
      chargeBeeSite={chargeBeeSite}
    />
  );
};

export default OwnerSubscription;
